import React from 'react';
import { FadeIn } from './FadeIn';
export function Features() {
  return <section id="por-que" className="py-[120px] px-[5%] bg-gris-oscuro" data-id="element-23">
      <FadeIn className="text-center mb-[70px]" data-id="element-24">
        <span className="inline-block bg-azul-neon/10 border border-azul-neon/30 text-acento text-[12px] font-semibold tracking-[2px] uppercase px-[16px] py-[6px] rounded-full mb-[18px]" data-id="element-25">
          Por qué elegirnos
        </span>
        <h2 className="font-rajdhani text-[clamp(32px,4vw,52px)] font-bold leading-[1.1] mb-[16px]" data-id="element-26">
          La Excelencia Mecánica{' '}
          <span className="text-acento" data-id="element-27">Es Nuestra Especialidad</span>
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[repeat(auto-fit,minmax(250px,1fr))] gap-[32px] max-w-[1200px] mx-auto" data-id="element-28">
        <FadeIn data-id="element-29">
          <div className="text-center p-[40px_28px] rounded-[16px] bg-gris-medio border border-white/5 transition-all duration-300 hover:border-azul-neon/30 hover:-translate-y-[4px] hover:shadow-[0_12px_40px_rgba(0,0,0,0.3)]" data-id="element-30">
            <div className="w-[70px] h-[70px] rounded-[20px] bg-gradient-to-br from-azul/20 to-azul-oscuro/30 border border-azul-neon/30 flex items-center justify-center mx-auto mb-[22px]" data-id="element-31">
              <i className="fas fa-car text-[28px] text-acento" data-id="element-32"></i>
            </div>
            <h3 className="font-rajdhani text-[20px] font-bold mb-[12px]" data-id="element-33">
              Todas las Marcas
            </h3>
            <p className="text-texto-gris text-[14px] leading-[1.7]" data-id="element-34">
              Trabajamos con autos nacionales e importados. Ningún vehículo es
              problema para nuestro equipo.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-35">
          <div className="text-center p-[40px_28px] rounded-[16px] bg-gris-medio border border-white/5 transition-all duration-300 hover:border-azul-neon/30 hover:-translate-y-[4px] hover:shadow-[0_12px_40px_rgba(0,0,0,0.3)]" data-id="element-36">
            <div className="w-[70px] h-[70px] rounded-[20px] bg-gradient-to-br from-azul/20 to-azul-oscuro/30 border border-azul-neon/30 flex items-center justify-center mx-auto mb-[22px]" data-id="element-37">
              <i className="fas fa-laptop-code text-[28px] text-acento" data-id="element-38"></i>
            </div>
            <h3 className="font-rajdhani text-[20px] font-bold mb-[12px]" data-id="element-39">
              Diagnóstico Digital
            </h3>
            <p className="text-texto-gris text-[14px] leading-[1.7]" data-id="element-40">
              Equipos de diagnóstico de última generación para detectar fallas
              con precisión milimétrica.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-41">
          <div className="text-center p-[40px_28px] rounded-[16px] bg-gris-medio border border-white/5 transition-all duration-300 hover:border-azul-neon/30 hover:-translate-y-[4px] hover:shadow-[0_12px_40px_rgba(0,0,0,0.3)]" data-id="element-42">
            <div className="w-[70px] h-[70px] rounded-[20px] bg-gradient-to-br from-azul/20 to-azul-oscuro/30 border border-azul-neon/30 flex items-center justify-center mx-auto mb-[22px]" data-id="element-43">
              <i className="fas fa-map-marker-alt text-[28px] text-acento" data-id="element-44"></i>
            </div>
            <h3 className="font-rajdhani text-[20px] font-bold mb-[12px]" data-id="element-45">
              Centro de la Ciudad
            </h3>
            <p className="text-texto-gris text-[14px] leading-[1.7]" data-id="element-46">
              Ubicados en Maipú 766, entre Pringles y Junín. Fácil acceso desde
              cualquier punto de San Luis.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-47">
          <div className="text-center p-[40px_28px] rounded-[16px] bg-gris-medio border border-white/5 transition-all duration-300 hover:border-azul-neon/30 hover:-translate-y-[4px] hover:shadow-[0_12px_40px_rgba(0,0,0,0.3)]" data-id="element-48">
            <div className="w-[70px] h-[70px] rounded-[20px] bg-gradient-to-br from-azul/20 to-azul-oscuro/30 border border-azul-neon/30 flex items-center justify-center mx-auto mb-[22px]" data-id="element-49">
              <i className="fas fa-heart text-[28px] text-acento" data-id="element-50"></i>
            </div>
            <h3 className="font-rajdhani text-[20px] font-bold mb-[12px]" data-id="element-51">
              Pasión por lo que Hacemos
            </h3>
            <p className="text-texto-gris text-[14px] leading-[1.7]" data-id="element-52">
              No falta la pasión en lo que amamos. Cada trabajo es una
              oportunidad de demostrar excelencia.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}